//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
//  -- Components ---------------------
//  -- Features -----------------------
import React, { useCallback, useEffect, useMemo, useState } from 'react';
//  -- Constants ----------------------
import { ArrowRightRounded, CheckCircleRounded, ContentCopy } from '@mui/icons-material';
import { Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, FormControl, InputLabel, Select, MenuItem, Chip, OutlinedInput, Checkbox, ListItemText, Autocomplete, TextField, Box } from '@mui/material';
import { DeleteModal } from 'components/Dialog';
import Loading from 'components/Loading';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { get } from 'lodash';
import { useDispatch } from 'react-redux';
import Slider from 'react-slick';
import { useOneWayBingo } from 'store/bingo/selectors';
import { handleDeleteOnewayBingo, handleLearningModuleCount, handleListOneWayBingo } from 'store/bingo/thunks';
import { useCurrentUser } from 'store/users/selectors';
import { useAllBook } from 'store/books/selectors';
import { useBookUnits } from 'store/booksUnits/selectors';
import GameLoteriaLoaader from './GameLoteriaLoaader';
import PreviewLoteria from './PreviewLoteria';
import CloneLoteriaModal from './CloneLoteriaModal';
import { handleDuplicateByAdmin } from 'store/worksheet/thunks';
import { useResources } from 'store/resources/selectors';
import { isVideo } from 'utils/lib/ebookHelper';
import PrintLoteria from '../PrintBingo/PrintLoteria';
import { useClassUsers } from 'store/userClasses/selectors';
import SentryWrap from 'components/Sentry';

const SampleNextArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <i className='fa' aria-hidden='true'></i>
        </div>
    );
};

const SamplePrevArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <i className='fa' aria-hidden='true'></i>
        </div>
    );
};

const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    className: "center",
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
    responsive: [
        {
            breakpoint: 1092,
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
};

export default function MyLoteria({ bookId, pageId, startGame, gameInitLoader, onEditGame = () => { }, gameEditLoader, gameType, newMaskId="" }) {
    const showAlert = useAlert();
    const [isLoading, setLoading] = useState(true);
    const [selectedGame, setSelectedGame] = useState({})
    const [gameDeleteLoader, setGameDeleteLoader] = useState(false);
    const [gameDuplicateLoader, setGameDuplicateLoader] = useState(false);
    const [getDeleteItem, setGetDeleteItem] = useState();
    const dispatch = useDispatch();
    const [deleteModal, setDeleteModal] = useState(false)
    const [duplicateModal, setDuplicateModal] = useState(false)
    const [selectedPages, setSelectedPages] = useState([])
    const [gameToDuplicate, setGameToDuplicate] = useState(null)
    const [currentBookPages, setCurrentBookPages] = useState([]);
    const currentUser = useCurrentUser();
    const bingoData = useOneWayBingo();
    const booksAllList = useAllBook();
    const bookUnitList = useBookUnits();
    const resources = useResources();
    const currentBook = booksAllList.find(book => book.id === bookId);
    const currentEbookPages = currentBook?.pages || [];
    const otherBookPages = bookUnitList.find(book => book.id === bookId)?.pages || [];
    const classUsers = useClassUsers();
    const classStudentUsers = classUsers?.filter(
        (obj) => obj?.role === "student"
    );
    const [cloneModal, setCloneModal] = useState(false);
    const [cloneGame, setCloneGame] = useState(null);

    // Generate array of objects from start to finish
    const generatePages = (start, finish) => {
      const arr = [];
      let id = 1;
      for (let i = Number(start); i <= Number(finish); i++) {
        arr.push({ id: id++, pageId: i });
      }
      return arr;
    };

    useEffect(() => {
        if (otherBookPages.length > 0) {
            const matches = otherBookPages?.find(item => {
              const startYear = parseInt(item.start, 10);
              const finishYear = parseInt(item.finish, 10);
              return pageId >= startYear && pageId <= finishYear;
            });
            if (matches) {
                const pagesArray = generatePages(matches?.start, matches?.finish);
                setCurrentBookPages(pagesArray);
            } else {
                setCurrentBookPages([]);
            }
        } else if (isVideo(bookId, resources)) {
            // Find parent object and filter only the matching video
            const videoResources = resources
            .map(parent => {
              const matchingVideos = parent.videos.filter(video => video.id === bookId);
              if (matchingVideos.length > 0) {
                return {
                  ...parent,
                };
              }
              return null;
            })
            .filter(Boolean)[0]; // return the first match
            if (videoResources?.videos) {
                // Create pages array from videos for dropdown
                const pagesFromVideos = videoResources.videos.map((video, index) => ({
                    id: index + 1,
                    pageId: video.id,
                    NumberMasked: video.displayName || `Page ${index + 1}`,
                    resource: video.src
                }));
                setCurrentBookPages(pagesFromVideos);
            } else {
                setCurrentBookPages([]);
            }
        } else {
            setCurrentBookPages(currentEbookPages);
        }
    }, [otherBookPages?.length, currentEbookPages?.length, currentEbookPages?.map(p => p.id).join(','), resources?.length, bookId]);

    const loadData = async () => {
        setLoading(true)
        const BingoList = {
            chapter: bookId,
            page: pageId,
            role: get(currentUser, 'role', ''),
            user_id: get(currentUser, 'id', '')
        }
        await dispatch(handleListOneWayBingo(BingoList));
        setLoading(false);
    }
    useEffect(() => {
        loadData();
    }, [pageId, gameType])

    const onDeleteGame = async (gameData) => {
        setGameDeleteLoader(gameData?.id)
        await dispatch(handleDeleteOnewayBingo(gameData?.id))
        setGameDeleteLoader(false)
    }

    const onDuplicateGame = async (gameData) => {
        setGameToDuplicate(gameData)
        setSelectedPages([])
        setDuplicateModal(true)
    }

    const handleDuplicateToPages = async () => {
        const selectedNumberMasked = selectedPages.map(selectedValue => {
                const page = currentBookPages.find(p => p.NumberMasked === selectedValue || `Page ${p.pageId}` === selectedValue);
                return page ? page.pageId : selectedValue;
            });
        if (selectedPages.length === 0) {
            showAlert("Please select at least one page", "warning")
            return
        }

        try {
            setGameDuplicateLoader(gameToDuplicate?.id)
            const duplicateData = {
                id: gameToDuplicate?.id,
                pages: selectedNumberMasked,
                type: 'bingo',
                book_id: bookId,
                resources: isVideo(bookId, resources) ? true : false
            }
            const duplicatedGame = await handleDuplicateByAdmin(duplicateData);
            setGameDuplicateLoader(false);
            setDuplicateModal(false);
            if (duplicatedGame?.success === true) {
                showAlert(`Lotería duplicated successfully to ${duplicatedGame?.mappedResults?.length} page(s)!`, "success");
            }
            if (duplicatedGame?.success === false) {
                showAlert(`Failed to duplicate lotería`, "error");
            }
        } catch (error) {
            showAlert("Error duplicating lotería", "error")
        } finally {
            setGameToDuplicate(null)
            setSelectedPages([])
        }
    }

    const handleOpenCloneModal = (gameData) => {
        setCloneGame(gameData);
        setCloneModal(true);
    };

    if (isLoading) {
        return (<GameLoteriaLoaader />);
    }
    if (bingoData.length == 0) {
        return (<div class="skeleton-wrapper">
            <div class="skeleton-card" style={{ textAlign: "center" }}>No lotería games available!</div>
        </div>
        )
    }
    const handleDeleteGame = async() => {
        await onDeleteGame(getDeleteItem);
        dispatch(handleLearningModuleCount({
            chapter: bookId,
            userId: currentUser.id,
            pageId: pageId,
        }));
        setDeleteModal(false);
    }

    return (
        <SentryWrap>
        <Slider {...settings}>
            {bingoData && bingoData?.map((item, index) => {
                return (
                    <div className='myUnitsGm' key={item.id} style={{ overflow: "hidden" }}>
                        <div className='draftImage-game frameStyle'>
                            <PreviewLoteria grid={item?.bingo_data} bingoSize={item?.configurations?.bingo_size} selectedType={item?.bingo_type} />
                        </div>
                        <div className='myUnitsTxt'>
                            <div className='myUnitsInfo' style={{ overflow: 'hidden', minWidth: 0 }}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                                    <Tooltip title={item?.criteria || 'Untitled'} placement="top">
                                        <label
                                            className='text-dark'
                                            style={{
                                                display: 'block',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                maxWidth: '100%',
                                            }}
                                        >
                                            {item?.criteria || 'Untitled'}
                                        </label>
                                    </Tooltip>
                                    <span
                                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                        onClick={() => handleOpenCloneModal(item)}
                                        className="text-dark"
                                    >
                                        <ContentCopy style={{ fontSize: 18 }} />
                                    </span>
                                </div>
                                {newMaskId !== "" && (
                                    <span>Pg. {newMaskId || '--'}</span>
                                )}      
                                <span>
                                    Lotería Size: {item?.configurations?.bingo_size
                                        ? `${item.configurations.bingo_size} X ${item.configurations.bingo_size}`
                                        : '--'}
                                </span>
                            </div>
                            <div className='loteriaUnitsBtns'>
                                <PrintLoteria
                                    bingoSize={item?.configurations?.bingo_size}
                                    selectedType={item?.bingo_type}
                                    grid={item?.bingo_data}
                                    classUsers={classStudentUsers}
                                    isGridValid={true}
                                    showSnack={showAlert}
                                 />
                                {currentUser?.role === 'teacher' && (
                                    <a onClick={async () => {
                                        if (gameInitLoader) {
                                            return false;
                                        }
                                        if (item?.bingo_data?.length > 0) {
                                            setSelectedGame(item);
                                            await startGame(item);
                                            setSelectedGame({});
                                        } else {
                                            showAlert("Something went wrong, please try with new lotería", "error");
                                        }
                                    }}
                                        className={`loteriaBtnsStart`}>
                                        <ArrowRightRounded />{gameInitLoader && selectedGame.id === item.id ? <Loading size={12} white /> : null} start
                                    </a>
                                )}
                            </div>
                            <div className='myUnitsBtm'><p><CheckCircleRounded /> My Creation</p></div>
                            <div style={{ display: 'flex', justifyContent: currentUser?.role === 'owe_admin' ? 'space-around' : 'space-between', alignItems: 'center', gap: '10px' }} className="px-4">
                                <div onClick={() => {
                                    onEditGame(item)
                                }}>
                                    <p className='text-dark' style={{ fontSize: 16, fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row' }}>Edit{gameEditLoader === item.id ? <Loading size={15} /> : null}</p>
                                </div>
                                {currentUser?.role === 'owe_admin' && (
                                    <div onClick={() => {
                                        onDuplicateGame(item)
                                    }}>
                                        <p className='text-dark' style={{ fontSize: 16, fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row' }}>Duplicate{gameDuplicateLoader === item.id ? <Loading size={15} /> : null}</p>
                                    </div>
                                )}
                                <div onClick={() => {
                                    setGetDeleteItem(item)
                                    // onDeleteGame(item)
                                    setDeleteModal(true);
                                }}>
                                    <p className='text-dark' style={{ fontSize: 16, fontWeight: '600', cursor: 'pointer' }}>Delete </p>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </Slider>
            <DeleteModal
                message={`Do you really want to delete this Lotería, "${getDeleteItem?.criteria ?? 'Untitled'}"`}
                deleteToggle={deleteModal}
                setDeleteToggle={setDeleteModal}
                loading={gameDeleteLoader}
                onDelete={handleDeleteGame}
            />
            
            <Dialog 
                open={duplicateModal} 
                onClose={() => setDuplicateModal(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Duplicate Lotería</DialogTitle>
                <DialogContent>
                    <div style={{ marginTop: '16px' }}>
                        <p style={{ marginBottom: '16px', fontSize: '14px', color: '#666' }}>
                            Select pages where you want to duplicate "{gameToDuplicate?.criteria || 'Untitled'}"
                        </p>
                        {otherBookPages.length > 0 ? (
                            <Autocomplete
                                multiple
                                options={currentBookPages}
                                getOptionLabel={(option) => option.id.toString()}
                                value={currentBookPages.filter(page => selectedPages.includes(String(page.pageId)))}
                                onChange={(event, newValue) => {
                                    setSelectedPages(newValue.map(page => String(page.pageId)));
                                }}
                                disableCloseOnSelect
                                renderOption={(props, option, { selected }) => (
                                    <li 
                                        {...props} 
                                        style={{ 
                                            display: 'flex', 
                                            alignItems: 'center',
                                            opacity: option.pageId === pageId ? 0.5 : 1,
                                            cursor: option.pageId === pageId ? 'not-allowed' : 'pointer'
                                        }}
                                        onClick={option.pageId === pageId ? (e) => e.stopPropagation() : props.onClick}
                                    >
                                        <Checkbox
                                            checked={selected}
                                            style={{ marginRight: 8 }}
                                            disabled={option.pageId === pageId}
                                        />
                                        <span>{option.id}</span>
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Select Pages"
                                        placeholder="Search pages..."
                                    />
                                )}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip
                                            variant="outlined"
                                            label={option.id}
                                            {...getTagProps({ index })}
                                            key={option.pageId}
                                        />
                                    ))
                                }
                            />
                        ) : (
                            <Autocomplete
                                multiple
                                options={currentBookPages}
                                getOptionLabel={(option) => option.NumberMasked || `Page ${option.pageId}`}
                                value={currentBookPages.filter(page => selectedPages.includes(page.NumberMasked || `Page ${page.pageId}`))}
                                onChange={(event, newValue) => {
                                    setSelectedPages(newValue.map(page => page.NumberMasked || `Page ${page.pageId}`));
                                }}
                                disableCloseOnSelect
                                renderOption={(props, option, { selected }) => (
                                    <li 
                                        {...props} 
                                        style={{ 
                                            display: 'flex', 
                                            alignItems: 'center',
                                            opacity: option.pageId === pageId ? 0.5 : 1,
                                            cursor: option.pageId === pageId ? 'not-allowed' : 'pointer'
                                        }}
                                        onClick={option.pageId === pageId ? (e) => e.stopPropagation() : props.onClick}
                                    >
                                        <Checkbox
                                            checked={selected}
                                            style={{ marginRight: 8 }}
                                            disabled={option.pageId === pageId}
                                        />
                                        <span>{option.NumberMasked || `Page ${option.pageId}`}</span>
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Select Pages"
                                        placeholder="Search pages..."
                                    />
                                )}
                                renderTags={(value, getTagProps) => (
                                    <Box
                                      sx={{
                                        maxHeight: 130,         // ✅ limit height to 120px
                                        overflowY: 'auto',      // ✅ enable vertical scrolling
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: 0.5,
                                      }}
                                    >
                                      {value.map((option, index) => (
                                        <Chip
                                            variant="outlined"
                                            label={option.NumberMasked || `Page ${option.pageId}`}
                                            {...getTagProps({ index })}
                                            key={option.pageId}
                                        />
                                      ))}
                                    </Box>
                                  )}
                            />
                        )}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDuplicateModal(false)}>
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleDuplicateToPages}
                        variant="contained"
                        disabled={gameDuplicateLoader || selectedPages.length === 0}
                    >
                        {gameDuplicateLoader ? <Loading size={15} white /> : 'Duplicate'}
                    </Button>
                </DialogActions>
            </Dialog>
            <CloneLoteriaModal
                open={cloneModal}
                onClose={() => {
                    setCloneModal(false);
                    setCloneGame(null);
                }}
                cloneGame={cloneGame}
                bookId={bookId}
                pageId={pageId}
                onSuccess={loadData}
            />
        </SentryWrap>
    )
}